import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchCompanyTableAndFilterSchema } from "model/CompanyModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [companyContextData, setCompanyContextData] = useState();

  const fetchCompanyContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:company", () =>
        fetchCompanyTableAndFilterSchema([])
      );
      if (response?.success) {
        setCompanyContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch company metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CompanyContext.Provider
      value={{
        fetchCompanyContextData,
        companyContextData,
        loading,
        error,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompanyContext = () => useContext(CompanyContext);
